import React from "react";
import MegaMenu from "./MegaMenu/MegaMenu";
import TopHeader from "./TopHeader";
import MainHeader from "./MainHeader/MainHeader";
import { useSelector } from "react-redux";
import classes from "./Header.module.css";
import { Link } from "react-router-dom";
import { BiHomeAlt2 } from "react-icons/bi";
import { MdOutlinePersonOutline } from "react-icons/md";
import { IoHeartOutline } from "react-icons/io5";
import { BsHandbag } from "react-icons/bs";

const Header = (props) => {
  const { MegaMenuData, categoryData, itemCount } = props;
  const { megaMenu } = useSelector((state) => state.megaMenuSlice);

  return (
    <>
      <header>
        <TopHeader />
        <MainHeader MegaMenuData={MegaMenuData} />
      </header>
      {megaMenu ? <MegaMenu categoryData={categoryData} /> : null}

      <div className={classes.sticky_navbar}>
        <div className={classes.sticky_info}>
          <Link to="/">
            <BiHomeAlt2 size={30} /> Home{" "}
          </Link>
        </div>
        <div className={classes.sticky_info}>
          <Link to="/cart">
            <BsHandbag size={30} /> Cart{" "}
            <span className={classes.counter}>
              {itemCount > 99 ? "99+" : itemCount}
            </span>
          </Link>
        </div>
        <div className={classes.sticky_info}>
          <Link to="/wishlist">
            <IoHeartOutline size={30} /> Wishlist{" "}
          </Link>
        </div>
        <div className={classes.sticky_info}>
          <Link to="/account-information">
            <MdOutlinePersonOutline size={30} /> Account{" "}
          </Link>
        </div>
      </div>
    </>
  );
};

export default Header;
